import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AppShell, Container, Loader, Center } from '@mantine/core';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Navigation from './components/Navigation';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Account from './pages/Account';
import Favorites from './pages/Favorites';
import AdminPanel from './pages/AdminPanel';
import AddListing from './pages/AddListing';
import Properties from './pages/Properties';
import PropertyDetail from './pages/PropertyDetail';
import Campgrounds from './pages/Campgrounds';
import CampgroundDetail from './pages/CampgroundDetail';

function AppContent() {
  const { loading } = useAuth();

  if (loading) {
    return (
      <Center h="100vh">
        <Loader size="lg" color="green" />
      </Center>
    );
  }

  return (
    <AppShell
      header={{ height: 70 }}
      padding="md"
    >
      <Navigation />
      <AppShell.Main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/account" element={<Account />} />
          <Route path="/favorites" element={<Favorites />} />
          <Route path="/add-listing" element={<AddListing />} />
          <Route path="/properties" element={<Properties />} />
          <Route path="/properties/:id" element={<PropertyDetail />} />
          <Route path="/campgrounds" element={<Campgrounds />} />
          <Route path="/campgrounds/:id" element={<CampgroundDetail />} />
          <Route path="/admin" element={<AdminPanel />} />
        </Routes>
      </AppShell.Main>
    </AppShell>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
